/// <reference path="../modules/blocks.exception.module.ts" />

module Blocks {
    export interface IExceptionService {
        catcher(message: string, reason?: string): void;
    }

    export class ExceptionService implements IExceptionService {
        static factoryId: string = "exception";

        catcher = (message: string, reason?: any) => { };

        constructor(private logger: Interfaces.ILoggerService) {
            this.catcher = (message: string, reason?: string) => this._catcher(message, logger, reason);
        }

        private _catcher(message: string, logger: Interfaces.ILoggerService, reason?: any) {
            logger.error(message, (reason ? reason : ''), "");
        }

    }

    exception.factory(ExceptionService.factoryId, [LoggerService.factoryId, (logger) => new ExceptionService(logger)]);
}
